import React from 'react';
const QuestionnaireHeader: React.FC = () => {
  return <>
      <h1 className="text-[#2c5530] text-center mb-2.5 text-4xl font-bold" data-id="element-30">
        🌿 TCM Constitution Questionnaire
      </h1>
      <p className="text-center text-gray-600 mb-8 italic" data-id="element-31">
        Constitution in Chinese Medicine Questionnaire (CCMQ)
      </p>
      <div className="bg-[#e8f5e8] p-5 rounded-lg mb-8 border-l-4 border-[#2c5530]" data-id="element-32">
        <h3 className="text-xl font-semibold mb-2" data-id="element-33">📋 Instructions</h3>
        <p className="mb-2" data-id="element-34">
          <strong data-id="element-35">Purpose:</strong> This questionnaire aims to survey your body
          constitution and subsequently provide a reference for future health
          management and clinical diagnosis.
        </p>
        <p className="mb-2" data-id="element-36">
          <strong data-id="element-37">Guidelines:</strong>
        </p>
        <ul className="list-disc ml-5 space-y-1" data-id="element-38">
          <li data-id="element-39">
            Please read every question carefully and choose the most suitable
            answer based on your actual situation or feeling in the{' '}
            <strong data-id="element-40">past year</strong>
          </li>
          <li data-id="element-41">
            If you are unsure of the answer to a specific question, choose the
            answer that is most similar to your actual situation
          </li>
          <li data-id="element-42">
            Answer all questions based on your situation in the past year
            (excluding the effect of drugs)
          </li>
          <li data-id="element-43">Give only one answer to each question</li>
        </ul>
      </div>
      <div className="bg-[#fff3cd] p-4 rounded-lg mb-6 border border-[#ffeaa7]" data-id="element-44">
        <h3 className="mt-0 text-[#856404] font-semibold text-lg mb-2" data-id="element-45">
          🎯 Response Scale
        </h3>
        <div className="flex flex-wrap gap-2" data-id="element-46">
          <div className="inline-block m-1 p-1 bg-white rounded text-sm" data-id="element-47">
            <strong data-id="element-48">1 - None:</strong> Never happened
          </div>
          <div className="inline-block m-1 p-1 bg-white rounded text-sm" data-id="element-49">
            <strong data-id="element-50">2 - Rarely:</strong> Occasionally happened
          </div>
          <div className="inline-block m-1 p-1 bg-white rounded text-sm" data-id="element-51">
            <strong data-id="element-52">3 - Sometimes:</strong> Sometimes it happened, but no
            regular pattern
          </div>
          <div className="inline-block m-1 p-1 bg-white rounded text-sm" data-id="element-53">
            <strong data-id="element-54">4 - Often:</strong> It happened most of the time
          </div>
          <div className="inline-block m-1 p-1 bg-white rounded text-sm" data-id="element-55">
            <strong data-id="element-56">5 - Always:</strong> It happened all the time
          </div>
        </div>
      </div>
    </>;
};
export default QuestionnaireHeader;